import React from "react";

const RejectionIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_4581_2)">
        <rect
          x="4"
          y="4.05859"
          width="16"
          height="15.9402"
          rx="4"
          fill="#FFE4E6"
        />
      </g>
      <path
        d="M12.7003 12.026L14.8505 9.889C14.9446 9.7952 14.9975 9.66798 14.9975 9.53533C14.9975 9.40267 14.9446 9.27545 14.8505 9.18165C14.7563 9.08785 14.6286 9.03516 14.4954 9.03516C14.3623 9.03516 14.2346 9.08785 14.1404 9.18165L11.9953 11.3236L9.85014 9.18165C9.75598 9.08785 9.62828 9.03516 9.49512 9.03516C9.36196 9.03516 9.23425 9.08785 9.1401 9.18165C9.04594 9.27545 8.99304 9.40267 8.99304 9.53533C8.99304 9.66798 9.04594 9.7952 9.1401 9.889L11.2902 12.026L9.1401 14.163C9.09323 14.2093 9.05603 14.2644 9.03064 14.3251C9.00526 14.3858 8.99219 14.4509 8.99219 14.5166C8.99219 14.5824 9.00526 14.6475 9.03064 14.7082C9.05603 14.7689 9.09323 14.824 9.1401 14.8703C9.18658 14.917 9.24188 14.9541 9.30282 14.9794C9.36375 15.0046 9.42911 15.0177 9.49512 15.0177C9.56113 15.0177 9.62649 15.0046 9.68742 14.9794C9.74835 14.9541 9.80366 14.917 9.85014 14.8703L11.9953 12.7283L14.1404 14.8703C14.1869 14.917 14.2422 14.9541 14.3031 14.9794C14.3641 15.0046 14.4294 15.0177 14.4954 15.0177C14.5615 15.0177 14.6268 15.0046 14.6877 14.9794C14.7487 14.9541 14.804 14.917 14.8505 14.8703C14.8973 14.824 14.9345 14.7689 14.9599 14.7082C14.9853 14.6475 14.9984 14.5824 14.9984 14.5166C14.9984 14.4509 14.9853 14.3858 14.9599 14.3251C14.9345 14.2644 14.8973 14.2093 14.8505 14.163L12.7003 12.026Z"
        fill="#961B01"
      />
      <defs>
        <filter
          id="filter0_d_4581_2"
          x="0"
          y="0.0585938"
          width="24"
          height="23.9414"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_4581_2"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_4581_2"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};

export default RejectionIcon;
